import { AddRounded } from '@mui/icons-material';
import { Button, Paper } from '@mui/material';
import { useState } from 'react';
import { AddToNewCollectionDialog } from '../AddToNewCollectionDialog';

interface AddToNewCollectionButtonProps {
  feedbackID: string;
}

export const AddToNewCollectionButton = ({
  feedbackID,
}: AddToNewCollectionButtonProps) => {
  const [isAddToNewCollectionDialogOpen, setIsAddToNewCollectionDialogOpen] =
    useState(false);

  const onAddToNewCollectionDialogClose = () => {
    setIsAddToNewCollectionDialogOpen(false);
  };

  return (
    <Paper elevation={12}>
      <Button
        startIcon={<AddRounded />}
        onClick={(event) => {
          event.stopPropagation();
          setIsAddToNewCollectionDialogOpen(true);
        }}
        fullWidth
        variant="text"
        size="medium"
        sx={{
          textAlign: 'start',
          justifyContent: 'flex-start',
        }}
      >
        Add to a new Collection
      </Button>

      {isAddToNewCollectionDialogOpen && (
        <AddToNewCollectionDialog
          onClose={onAddToNewCollectionDialogClose}
          feedbackID={feedbackID}
        />
      )}
    </Paper>
  );
};
